import { render } from "./Item5.vue?vue&type=template&id=f511b69e"
import script from "./Item5.vue?vue&type=script&lang=ts"
export * from "./Item5.vue?vue&type=script&lang=ts"
script.render = render

export default script